if (!customElements.get('pastael-featured-collection-slider')) {
  class PastaelFeaturedCollectionSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.dots = this.querySelectorAll('[data-slider-dot]');
      this.slides = this.querySelectorAll('[data-slider-slide]');

      if (!this.track || !this.slides.length) return;

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const slide = this.slides[index];
          if (!slide) return;

          this.track.scrollTo({
            left: slide.offsetLeft - this.track.offsetLeft,
            behavior: 'smooth',
          });
        });
      });

      this.handleScroll = this.handleScroll.bind(this);
      this.updateScrollState = this.updateScrollState.bind(this);

      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      this.handleScroll();

      this.resizeObserver = new ResizeObserver(this.updateScrollState);
      this.resizeObserver.observe(this.track);
      this.slides.forEach((slide) => this.resizeObserver.observe(slide));
      this.updateScrollState();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    updateScrollState() {
      if (!this.track) return;

      const isScrollable = this.track.scrollWidth > this.track.clientWidth + 1;
      this.classList.toggle('is-scrollable', isScrollable);
      this.track.classList.toggle('is-scrollable', isScrollable);
      this.handleScroll();
    }

    handleScroll() {
      if (!this.track || !this.slides.length || !this.dots.length) return;

      const trackLeft = this.track.scrollLeft;
      let activeIndex = 0;
      let smallestDistance = Number.POSITIVE_INFINITY;

      this.slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - this.track.offsetLeft - trackLeft);
        if (distance < smallestDistance) {
          smallestDistance = distance;
          activeIndex = index;
        }
      });

      this.dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }
  }

  customElements.define('pastael-featured-collection-slider', PastaelFeaturedCollectionSlider);
}
